<div class="page-container">
  <app-card>
    <app-card-header>
      <app-card-title>
        <div class="header-row">
          <!-- <div class="form-actions"> -->
          <app-button class="" variant="filled" (click)="createNew()" *hasPermission="'lookup-list.create'"
            data-testid="new-lookup-list-button">
            <app-icon name="plus" />
            {{ 'lookupList.new' | translate }}
          </app-button>
          <!-- </div> -->
        </div>
      </app-card-title>
    </app-card-header>

    <app-card-content>
      <app-entity-list-selector entityType="lookup-lists" mode="single" [showActions]="false"
        [showInactiveFilter]="true" (edit)="edit($event)" data-testid="lookup-lists-selector" />
    </app-card-content>
  </app-card>
</div>